import React from 'react'
import FormViewer from '../../../components/FormViewer'
import HttpServices from '../../../utils/Http.services'
import { checkTextTranslation, imageAddress, translate } from '../../../utils/useful'

class FourthStep extends React.Component {
    state = {
        headers: [
            // { key: 'image', type: 'ProfileImageInput', col: '3', theme: 'transparent', information: { label: '{{lang}}yonnect.addNew.titles.appletImage', placeholder: '{{lang}}yonnect.addNew.titles.appletName', placeHolderImage: '', defaultImage: '/images/applet-def.jpg', required: false, cropper: true, ratio: '1:1', single: true } },
            // { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}column', placeholder: 'appletName', required: true } },
            // { key: 'description', type: 'TextAreaInput', information: { placeholder: '{{lang}}description', required: false } }
            // { key: 'col', type: 'SelectInput', information: { label: '{{lang}}column', default: '6', type: 'local', items: [{ value: '6', title: '50%' }, { value: '8', title: '66%' }, { value: '9', title: '75%' }, { value: '12', title: '100%' }], placeholder: '{{lang}}select', required: false }, showMain: true },
            // { type: 'AdvancedSelectInput', key: 'user', information: { address: 'getHubsWithAddAppletPermission', filter: {}, fields: { title: 'targetHub.fullname', value: 'targetHub._id', image: 'targetHub.image' }, type: 'api', placeholder: '{{lang}}select', icon: "/images/search.svg", required: true } },

        ]
    }

    componentDidMount() {
        // this.getAllApplets()
        // let applet = this.props.initData?.applet
        // console.log("LOGG", this.props.initData?.widget?.headers)

    }

    nextPage = (item) => {
        let data = this.form.getForm()
        // if (data != null) {
        this.props.setData(({ configurtion: data }), () => {
            // this.props.setData(({ applet: item }) => {

            this.props.changeStage('addwidgets')

        })
        // }

    }


    render() {
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">

                <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc', zIndex: 10 }}>
                    <div className='mb-2 flexcb'>
                        <div>
                            <button onClick={() => this.props.lastStage()} className='flexc'>
                                <div className=' rotate-180 br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}>
                                    <img className='' src="/assets/icons/useful/angle-right.svg" height={20} />
                                </div>
                                <h2 style={{ color: '#ffffffcc', fontSize: 18 }} className="  mx-2" >{translate('Select Widgets')}</h2>
                            </button>
                        </div>
                        <div>
                            <button className="flexcb p-1 " style={{ borderRadius: 9, border: '1px solid #d8d8d8cd' }}>
                                <div className="px-3" style={{}} onClick={() => this.nextPage()}>
                                    <p style={{ color: '#fafafa' }}>Next</p>
                                </div>
                                <div className=' default-btn-icon  ws-25 hs-25 flexcc' style={{}}>
                                    {/* <div className="mrd-1 default-btn-icon"> */}
                                    <img className='invert' src="/assets/icons/useful/angle-right.svg" height={20} />
                                    {/* <p style={{ color: '#fff', padding: '3px 9px' }}>+</p> */}
                                    {/* </div> */}
                                </div>
                            </button>
                        </div>
                    </div>


                    {/* <div >
                        <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                            <input className="py-1 px-2 w-100" placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                        </div>
                    </div> */}
                </div>
                <div className="w-100 mt-2 ">

                    <FormViewer ref={el => this.form = el} headers={this.props.initData?.widget?.headers} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} />
                </div>
            </div>
        );
    }
}

export default FourthStep;